import { useContext } from 'react'
import { AuthorizationContext } from 'src/contexts'

export const useAuthorizedState = () => {
  const [state] = useContext(AuthorizationContext)
  return state
}
